export default __webpack_public_path__ + "static/media/Ellipse15.65b7304c.png";